import React from 'react';
import { Route } from 'react-router-dom';
import { SubscriptionAdminRoute } from '../SubscriptionAdminRoute';
import AdminSubscriptionsDashboard from '../../Admin-Subscriptions/Dashboard';
import WorkflowPage from '../../Admin-Subscriptions/WorkflowPage';
import PlansPage from '../../Admin-Subscriptions/PlansPage';
import OffersPage from '../../Admin-Subscriptions/OffersPage';
import CustomersPage from '../../Admin-Subscriptions/CustomersPage';
import ContractsPage from '../../Admin-Subscriptions/ContractsPage';
import PlanRequestsPage from '../../Admin-Subscriptions/PlanRequestsPage';
import PaymentSetupPage from '../../Admin-Subscriptions/PaymentSetupPage';
import SubscriptionsPage from '../../Admin-Subscriptions/SubscriptionsPage';
import InvoicesPage from '../../Admin-Subscriptions/InvoicesPage';
import ReportsPage from '../../Admin-Subscriptions/ReportsPage';
import OperationsPage from '../../Admin-Subscriptions/OperationsPage';

const guard = (element) => <SubscriptionAdminRoute element={element} />;

export const adminSubscriptionRoutes = [
  <Route
    key="admin-subscriptions"
    path="/admin-subscriptions"
    element={guard(<AdminSubscriptionsDashboard />)}
  />,
  <Route
    key="admin-subscriptions-workflow"
    path="/admin-subscriptions/workflow"
    element={guard(<WorkflowPage />)}
  />,
  <Route
    key="admin-subscriptions-plans"
    path="/admin-subscriptions/plans"
    element={guard(<PlansPage />)}
  />,
  <Route
    key="admin-subscriptions-offers"
    path="/admin-subscriptions/offers"
    element={guard(<OffersPage />)}
  />,
  <Route
    key="admin-subscriptions-customers"
    path="/admin-subscriptions/customers"
    element={guard(<CustomersPage />)}
  />,
  <Route
    key="admin-subscriptions-plan-requests"
    path="/admin-subscriptions/plan-requests"
    element={guard(<PlanRequestsPage />)}
  />,
  <Route
    key="admin-subscriptions-contracts"
    path="/admin-subscriptions/contracts"
    element={guard(<ContractsPage />)}
  />,
  <Route
    key="admin-subscriptions-payment"
    path="/admin-subscriptions/payment-setup"
    element={guard(<PaymentSetupPage />)}
  />,
  <Route
    key="admin-subscriptions-subs"
    path="/admin-subscriptions/subscriptions"
    element={guard(<SubscriptionsPage />)}
  />,
  <Route
    key="admin-subscriptions-invoices"
    path="/admin-subscriptions/invoices"
    element={guard(<InvoicesPage />)}
  />,
  <Route
    key="admin-subscriptions-reports"
    path="/admin-subscriptions/reports"
    element={guard(<ReportsPage />)}
  />,
  <Route
    key="admin-subscriptions-operations"
    path="/admin-subscriptions/operations"
    element={guard(<OperationsPage />)}
  />,
];
